import React from 'react';
import moment from 'moment';
import type Moment from 'moment';

import { Box } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { DatePicker } from '@fortress-technology-solutions/fortress-component-library/Organisms';

import { parseCalendarDateUtc } from '../../../utils/date-helpers';

type Props = {
  value: ?(string | Date | Moment),
  onChange: Function,
};

// Picked values stay as-is; API values are parsed as a UTC calendar day
const toPickerValue = (value) =>
  moment.isMoment(value) ? value : parseCalendarDateUtc(value);

export const CalendarDatePicker = ({ value, onChange }: Props) => (
  <Box sx={{ minWidth: 170 }}>
    <DatePicker
      value={toPickerValue(value)}
      onChange={onChange}
      fullWidth
      helperText={null}
    />
  </Box>
);
